exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TwmsMaterialStyle_rightContent__267fO {\n  /* position: relative; */\n  float: left;\n  z-index: 2;\n  overflow: auto; }\n\n.TwmsMaterialStyle_rightContentMobile__iWalJ {\n  width: 100%;\n  position: relative;\n  float: left;\n  z-index: 2;\n  overflow: auto; }\n\n.TwmsMaterialStyle_rightContentDisplay__3X2Ej {\n  background: #fff;\n  padding: 10px 20px 20px 20px; }\n", ""]);

// exports
exports.locals = {
	"rightContent": "TwmsMaterialStyle_rightContent__267fO",
	"rightContentMobile": "TwmsMaterialStyle_rightContentMobile__iWalJ",
	"rightContentDisplay": "TwmsMaterialStyle_rightContentDisplay__3X2Ej"
};